module.exports = __webpack_public_path__ + "static/pd-mobile-d23f79a45972117c820bdce3a6e209f9.png";